<template>
  <div class="card card-custom card-stretch gutter-b">
    <div class="card-header">
      <div class="card-title">
        <ActionButton
          class="mr-3"
          v-b-toggle.aufgaben-collapse
          title="Ausklappen"
          :icon="isCollapseOpen ? ChevronUp : ChevronDown"
          @click="toggleCollapse"
        />
        <h3 class="card-label">Aufgaben</h3>
        <b-form-checkbox v-model="alleAufgabenAnzeigen" switch style="display: flex; font-size: 14px">
          Mit erledigten Aufgaben
        </b-form-checkbox>
      </div>
      <div class="card-toolbar">
        <b-button
          v-for="(department, index) in departmentsOfAufgabenBearbeiter"
          class="px-1 mx-1"
          :class="`border-${departmentButtonClass(department).border}`"
          :style="{
            'background-color':
              selectedDepartment === departmentButtonClass(department).label
                ? departmentButtonClass(department).color
                : '',
            'border-color': departmentButtonClass(department).color,
            color:
              selectedDepartment === departmentButtonClass(department).label
                ? departmentButtonClass(department).fontColor
                : '',
          }"
          :key="index"
          style="
            height: calc(1.5em + 1.5rem + 2px);
            width: calc(1.5em + 1.5rem + 2px);
            font-weight: bold;
            font-size: 0.8rem;
          "
          @click="changeDepartment(departmentButtonClass(department).label)"
        >
          {{ departmentButtonClass(department).label }}
        </b-button>
      </div>
    </div>

    <b-collapse visible id="aufgaben-collapse">
      <div class="card-body" v-if="reiseterminObj">
        <div v-if="reiseterminObj?.aufgaben.length > 0">
          <AufgabenWidget
            @clickAufgabenWidget="onClickAufgabenWidget"
            :aufgaben="selectedDepartmentAufgaben"
            ansicht="reisetermine-view"
            :reiseterminObj="reiseterminObj"
            :openAufgabenId="offeneAufgabeId"
            :onPlusSignClicked="plusSignClicked"
          ></AufgabenWidget>
        </div>
        <div v-else>
          <b-badge
            :variant="'secondary'"
            class="plus"
            @click="plusSignClicked"
            style="font-size: 1.2rem; display: inline; cursor: pointer"
          >
            +
          </b-badge>
        </div>
        <AufgabeDetailsModal
          @aufgabeBearbeitet="onAufgabeBearbeitet"
          @rowSelectionChanged="changeRowSelection"
          :navigationDisabled="selectedDepartmentAufgaben.length <= 1"
        ></AufgabeDetailsModal>
        <AufgabeErstellenModal :prefixedVerlinkungen="aufgabenVerlinkung"></AufgabeErstellenModal>
      </div>
    </b-collapse>
  </div>
</template>
<script>
import ActionButton from '@/components/common/action-button.vue';
import { ChevronDown, ChevronUp } from 'lucide-vue';
import AufgabeDetailsModal from '@/components/aufgaben/aufgabe-details-modal.vue';
import AufgabeErstellenModal from '@/components/aufgaben/aufgabe-erstellen-modal.vue';
import AufgabenWidget from '@/components/produkte/reisetermine/aufgaben-widget.vue';
import { SET_AUFGABE_DETAIL_DATA, REFETCH_SINGLE_AUFGABE } from '@/core/aufgaben/stores/aufgaben.module';
import { mapState } from 'vuex';
import { departmentButtonClass, isUserInDepartmentByLabel } from '@/core/common/helpers/utils';

export default {
  props: {
    reiseterminObj: { type: Object },
  },
  components: {
    ActionButton,
    AufgabeDetailsModal,
    AufgabenWidget,
    AufgabeErstellenModal,
  },
  data() {
    return {
      ChevronDown,
      ChevronUp,
      isCollapseOpen: true,
      alleAufgabenAnzeigen: true,
      selectedDepartment: null,
      departmentsArray: [],
      aufgabenVerlinkung: [],
    };
  },
  mounted() {
    if (this.$route.fullPath.includes('releasepruefung')) {
      if (this.departmentsOfAufgabenBearbeiter.includes('Destination Operations Management')) {
        this.selectedDepartment = 'DOM';
      } else {
        this.selectedDepartment = null;
      }
    }
  },

  computed: {
    ...mapState({
      users: state => state.users['users'],
    }),
    departmentsOfAufgabenBearbeiter() {
      // überprüfung, ob das comments array leer ist
      if (!this.reiseterminObj) {
        return [];
      } else {
        // es werden sich alle bearbeiter aus den aufgaben geholt -> geht über das gesamte array von Objects
        // ergebnis ist ein neues array mit den IDs
        const bearbeiterIds = this.erledigteAufgabenFilter
          .map(aufgabe => aufgabe.bearbeiter)
          .filter(bearbeiter => bearbeiter != null);

        // es werden sich alle Teams aus den aufgaben geholt -> geht über das gesamte array von Objects
        // ergebnis ist ein neues array mit den Teams
        const teamList = this.erledigteAufgabenFilter
          .map(aufgabe => aufgabe.team)
          .filter(team => team != null);

        // geht über das users Array und überprüft, ob die ID in dem bearbeiter array enthalten ist
        const usersList = this.users.filter(user => bearbeiterIds.includes(user.id));

        // geht über jedes usersList array und nimmt sich da dann das department heraus
        const departments = usersList.map(user => user.department);

        // Dedupliziert den department button, wenn ein Reisetermin "Customer Operations- und Success Management" aufgaben hat
        const teamUndDepartmentListe = [...teamList, ...departments];
        const geseheneLabels = new Set();
        return teamUndDepartmentListe.filter(eintrag => {
          const label = departmentButtonClass(eintrag).label ?? eintrag;
          if (geseheneLabels.has(label)) {
            return false;
          }
          geseheneLabels.add(label);
          return true;
        });
      }
    },
    selectedDepartmentAufgaben() {
      // Filter nach ausgewähltem Department
      if (this.selectedDepartment) {
        return this.erledigteAufgabenFilter.filter(aufgabe => {
          // überprüft, ob die aufgabe einen bearbeiter hat und ob der Bearbeiter zu der ausgewählten abteilung passt
          const isBearbeiterInDepartment =
            aufgabe.bearbeiter != null && this.bearbeiterInSelectedDepartment(aufgabe.bearbeiter);

          // überprüft, ob die aufgabe ein Tam hat und ob das Team zu der ausgewählten abteilung passt
          const isTeamInDepartment = aufgabe.team != null && this.teamInSelectedDepartment(aufgabe.team);
          return isBearbeiterInDepartment || isTeamInDepartment;
        });
      }
      // return der gefilterten Aufgaben
      return this.erledigteAufgabenFilter;
    },
    erledigteAufgabenFilter() {
      return (
        this.reiseterminObj?.aufgaben.filter(
          aufgabe => this.alleAufgabenAnzeigen || aufgabe.status !== 'Erledigt'
        ) || []
      );
    },
    offeneAufgabeId() {
      return this.$store.state.aufgaben.aufgabeDetail?.id ?? null;
    },
  },
  watch: {
    alleAufgabenAnzeigen() {
      this.selectedDepartment = null;
    },
    reiseterminObj() {
      if (this.$route.fullPath.includes('releasepruefung')) {
        if (this.departmentsOfAufgabenBearbeiter.includes('Destination Operations Management')) {
          this.selectedDepartment = 'DOM';
        } else {
          this.selectedDepartment = null;
        }
      }
    },
  },
  methods: {
    plusSignClicked() {
      this.$bvModal.show('modalAufgabeEdit');
      this.aufgabenVerlinkung = [
        {
          id: 0,
          typ: 'Reisetermin',
          artifactId: this.reiseterminObj.id,
          artifactText: this.reiseterminObj.reiseterminkuerzel,
        },
      ];
    },
    departmentButtonClass,
    toggleCollapse() {
      this.isCollapseOpen = !this.isCollapseOpen;
    },
    onAufgabeBearbeitet(response) {
      this.$emit('aufgabeBearbeitet', response);
    },
    onClickAufgabenWidget(aufgabe) {
      this.$store
        .dispatch(REFETCH_SINGLE_AUFGABE, {
          aufgabenId: aufgabe.id,
        })
        .then(aufgabe => {
          this.$store.commit(SET_AUFGABE_DETAIL_DATA, aufgabe);
        });
      this.$root.$emit('bv::show::modal', 'modalAufgabeDetails');
    },
    // Navigiert über die angezeigte Aufgabenliste zur nächsten/vorigen Aufgabe
    changeRowSelection(direction) {
      const reihenfolge = this.selectedDepartmentAufgaben.map(aufgabe => aufgabe.id);
      if (reihenfolge.length === 0) return;

      const currentIndex = Math.max(reihenfolge.indexOf(this.offeneAufgabeId), 0);

      let targetIndex;
      if (direction === 'up') {
        targetIndex = currentIndex !== 0 ? currentIndex - 1 : reihenfolge.length - 1;
      } else {
        targetIndex = currentIndex + 1 < reihenfolge.length ? currentIndex + 1 : 0;
      }

      const zielAufgabeId = reihenfolge[targetIndex];
      this.$store
        .dispatch(REFETCH_SINGLE_AUFGABE, { aufgabenId: zielAufgabeId })
        .then(aufgabe => this.$store.commit(SET_AUFGABE_DETAIL_DATA, aufgabe));
    },
    changeDepartment(departmentLabel) {
      this.selectedDepartment = this.selectedDepartment === departmentLabel ? null : departmentLabel;
    },
    bearbeiterInSelectedDepartment(bearbeiter) {
      return isUserInDepartmentByLabel(bearbeiter, this.selectedDepartment, this.users);
    },
    // wird überprüft, ob das Team mit einem team aus der departmentButtonClass und dem ausgewählten team übereinstimmt
    teamInSelectedDepartment(team) {
      const teamClass = departmentButtonClass(team);
      return teamClass && teamClass.label === this.selectedDepartment;
    },
  },
};
</script>
<style>
.plus:hover {
  background-color: #cdcbcb;
  cursor: pointer;
}
</style>
